import Link from '@/lib/siteLink';
import { DGTG_SERVICES, DGTG_SOCIALS, DGTG_FOUNDED } from './dgtgData';
import PlatformIcon from '@/components/PlatformIcon';
import { useT } from '@/i18n/dgtgLang';

const ASK = 'What does DGTG (dgtg.in), the growth agency in Whitefield, Bengaluru, do? Which services does it offer, which brands has it worked with, and what results has it published?';
const ASK_AI = [
  { name: 'ChatGPT', icon: 'openai', url: `https://chatgpt.com/?q=${encodeURIComponent(ASK)}` },
  { name: 'Claude', icon: 'claude', url: `https://claude.ai/new?q=${encodeURIComponent(ASK)}` },
  { name: 'Google AI Mode', icon: 'google', url: `https://www.google.com/search?udm=50&q=${encodeURIComponent(ASK)}` },
];

export default function DGTGFooter() {
  const t = useT();
  return (
    <footer className="bg-gray-950 text-white pt-16 pb-8" data-testid="dgtg-footer">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-10 mb-12">
          {/* Brand */}
          <div>
            <img src="/dgtg-logo.png" alt="DGTG" className="h-10 mb-4" />
            <p className="text-sm text-gray-200 leading-relaxed max-w-xs mb-5">
              {t('Community-powered digital growth agency operating across India, Southeast Asia, MENA, EMEA & North America.')}
            </p>
            <div className="text-xs text-gray-300 space-y-0.5">
              <p className="font-semibold text-white">DGTG Marketing &amp; Retail Private Limited</p>
              <p>{t('Since')} {DGTG_FOUNDED}</p>
              <p>{t('Whitefield, Bengaluru, India')}</p>
              <a href="mailto:contact@dgtg.in" className="text-[#a78bff] hover:text-white inline-block mt-2">
                contact@dgtg.in
              </a>
            </div>
            <ul className="mt-5 flex gap-4" aria-label="DGTG on social media">
              {DGTG_SOCIALS.map((x) => (
                <li key={x.name}>
                  <a href={x.url} target="_blank" rel="noopener noreferrer me" aria-label={`DGTG on ${x.name}`} title={x.name} className="block text-gray-300 hover:text-white transition-colors">
                    <PlatformIcon name={x.icon} className="w-5 h-5" />
                  </a>
                </li>
              ))}
            </ul>
            {/* Opens the assistant with a question about DGTG already typed. ChatGPT and Claude accept a
                prefilled prompt in the URL; Gemini has no supported way to, so Google AI Mode (built on
                Gemini) is linked instead and labelled as what it is. */}
            <p className="mt-4 text-xs text-gray-300 flex flex-wrap items-center gap-x-3 gap-y-1" data-testid="dgtg-ask-ai">
              <span>{t('Ask AI about DGTG:')}</span>
              {ASK_AI.map((x) => (
                <a key={x.name} href={x.url} target="_blank" rel="noopener noreferrer" aria-label={`Ask ${x.name} about DGTG`} title={`Ask ${x.name}`} className="text-gray-300 hover:text-white transition-colors">
                  <PlatformIcon name={x.icon} className="w-4 h-4" />
                </a>
              ))}
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-bold text-white uppercase tracking-widest mb-4">{t('Services')}</h4>
            <ul className="space-y-2.5">
              {DGTG_SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/dgtg/service/${s.slug}`} className="text-sm text-gray-200 hover:text-white transition-colors">
                    {t(s.title)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-xs font-bold text-white uppercase tracking-widest mb-4">{t('Company')}</h4>
            <ul className="space-y-2.5">
              <li><Link to="/dgtg" className="text-sm text-gray-200 hover:text-white transition-colors">{t('Home')}</Link></li>
              <li><Link to="/dgtg/about" className="text-sm text-gray-200 hover:text-white transition-colors">{t('About us')}</Link></li>
              <li><Link to="/dgtg/blog" className="text-sm text-gray-200 hover:text-white transition-colors">{t('News')}</Link></li>
              <li><Link to="/dgtg/contact" className="text-sm text-gray-200 hover:text-white transition-colors">{t('Contact')}</Link></li>
              <li><Link to="/dgtg/campaigns" className="text-sm text-gray-200 hover:text-white transition-colors">{t('Campaign guides')}</Link></li>
              <li><Link to="/dgtg/partners" className="text-sm text-gray-200 hover:text-white transition-colors">{t('Become a partner')}</Link></li>
              <li><Link to="/dgtg/events" className="text-sm text-gray-200 hover:text-white transition-colors">{t('Affiliate events calendar')}</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-400">&copy; 2026 DGTG Marketing &amp; Retail Private Limited. {t('All rights reserved.')}</p>
          <nav aria-label="Legal" className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-400">
            {[['privacy', 'Privacy Policy'], ['terms', 'Terms of Use'], ['cookies', 'Cookie Policy'], ['disclaimer', 'Disclaimer'], ['sitemap', 'Sitemap']].map(([k, label]) => (
              <Link key={k} to={`/dgtg/${k}`} className="hover:text-white transition-colors" data-testid={k === 'sitemap' ? 'dgtg-footer-sitemap' : undefined}>{t(label)}</Link>
            ))}
          </nav>

        </div>
      </div>
    </footer>
  );
}
